import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function normalizeLegacyHashbangUrl(): boolean {
  if (!window.location.hash.startsWith('#!/')) return false;

  const legacyUrl = window.location.hash.slice(3);
  const queryIndex = legacyUrl.indexOf('?');
  const legacyPath = queryIndex >= 0 ? legacyUrl.slice(0, queryIndex) : legacyUrl;
  const legacyQuery = queryIndex >= 0 ? legacyUrl.slice(queryIndex + 1) : undefined;
  const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
  const basePath = new URL(baseHref, window.location.origin).pathname.replace(/\/$/, '');
  const path = `${basePath}/${legacyPath.replace(/^\/+/, '')}`.replace(/\/{2,}/g, '/') || '/';
  const query = legacyQuery !== undefined ? `?${legacyQuery}` : window.location.search;
  const target = `${path}${query}`;

  if (`${window.location.pathname}${window.location.search}` === target) {
    window.history.replaceState(null, '', target);
    return false;
  }

  window.location.replace(target);
  return true;
}

const redirectedFromLegacyHashbangUrl = normalizeLegacyHashbangUrl();

if (!redirectedFromLegacyHashbangUrl) {
  const gmoScript = document.createElement('script');
  gmoScript.src = environment.mulPayTokenUrl;
  gmoScript.type = 'text/javascript';
  document.head.appendChild(gmoScript);

  bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch((err) => console.error(err));
}
